export default __webpack_public_path__ + "static/media/colorful_forest.2bfb2b8e.jpg";